import React from 'react';
import { CardColor } from '../types';
import { TowerIcon } from '../constants';
import { Language } from '../data/translations';

const ChromabowChoiceModal: React.FC<{
    onChoose: (color: CardColor) => void;
    availableColors: CardColor[];
    language?: Language;
}> = ({ onChoose, availableColors }) => {
    const colorHexMap: Record<CardColor, string> = {
        [CardColor.Red]: '#ef4444', [CardColor.Pink]: '#ec4899', [CardColor.Green]: '#22c55e',
        [CardColor.Black]: '#475569', [CardColor.Purple]: '#a855f7', [CardColor.Yellow]: '#eab308',
    };
    return (
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center z-40">
            <h2 className="text-4xl font-bold mb-8 text-slate-300 text-shadow-lg">Chromabow: Choose a Deck</h2>
            <div className="grid grid-cols-3 gap-6">
                {availableColors.map(color => (
                    <div key={color} onClick={() => onChoose(color)}
                        className="flex flex-col items-center justify-center gap-2 p-4 bg-slate-800/70 rounded-lg border-2 border-slate-600 cursor-pointer transform hover:scale-110 hover:border-slate-300 transition-all duration-300">
                        <TowerIcon className="w-16 h-16" color={colorHexMap[color]} />
                        <span className="font-bold" style={{ color: colorHexMap[color] }}>{color}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChromabowChoiceModal;
